// ToggleSwitch.tsx
import React from "react";
import { Switch, FormControlLabel, Box, Typography } from "@mui/material";
import { propsToClassKey } from "@mui/styles";

interface ToggleSwitchProps {
  on: boolean;
  label: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  on,
  label,
  onChange,
  disabled,
}) => {
  const onSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    if (onChange) {
      onChange(event);
    }
  };
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Typography>{label}</Typography>
      <FormControlLabel
        control={
          <Switch
            disabled={disabled}
            checked={on}
            onChange={onChange}
            inputProps={{ "aria-label": label }}
            sx={{
              "& .MuiSwitch-track": {
                border: 1,
              },
            }}
          />
        }
        label=""
        labelPlacement="start"
        sx={{ margin: 0 }}
      />
    </Box>
  );
};
